import Const from 'Utils/Consts'
import { type FC, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { VisitsTabsEnum } from 'Application/Visits/Actions/enums'

interface VisitMainDataProps {
  data: any
}

const VisitMainData: FC<VisitMainDataProps> = ({ data }) => {
  const mapRef = useRef<HTMLDivElement | null>(null)
  const mapInstance = useRef<any>(null)
  const markerRef = useRef<any>(null)

  const [t] = useTranslation()
  const [searchParams] = useSearchParams()

  const initializeMap = () => {
    if (!mapRef.current || !(window as any).L) return

    mapInstance.current = new (window as any).L.Map(mapRef.current, {
      key: Const.env.REACT_APP_NESHAN_MAP_API_KEY,
      maptype: 'dreamy',
      center: [data?.latitude ?? 35.6892, data?.longitude ?? 51.389],
      zoom: 17,
    })

    markerRef.current = (window as any).L.marker(
      [data?.latitude ?? 35.6892, data?.longitude ?? 51.389],
      {
        draggable: false,
      },
    ).addTo(mapInstance.current)

    return () => {
      mapInstance.current?.remove()
    }
  }

  useEffect(() => {
    initializeMap()

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove()
        mapInstance.current = null
      }
    }
  }, [])

  const getColor = () => {
    switch (isDraft ? data.assignedDraftVisitStatus : data.visitStatus) {
      case 1:
        return 'info'
      case 2:
        return 'success'
      case 3:
        return 'error'
      default:
        return 'warning'
    }
  }

  const tabValue: VisitsTabsEnum = Number(searchParams.get('tabValue'))

  const isDraft = data?.draftVisitId && tabValue === VisitsTabsEnum.Drafts

  console.log(isDraft ? t(data?.assignedDraftVisitStatusTitle) : t(data?.visitStatusTitle))

  return (
    <>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">نوع درخواست:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.insuranceTypeTitle}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">
          {isDraft ? t('DRAFT_VISIT_STATUS') : t('VISIT_STATUS')}:
        </span>
        <span className={`label label-soft-${getColor()}`}>
          {isDraft ? t(data?.assignedDraftVisitStatusTitle) : t(data?.visitStatusTitle)}
        </span>
      </div>

      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">
          {isDraft ? t('DRAFT_VISIT_NUMBER') : t('INSPECTION_NUMBER')}:
        </span>
        <span className="text-sm font-semibold text-gray-800">
          {(isDraft ? data?.draftNumber : data?.inspectionNumber) ?? '-'}
        </span>
      </div>

      {!isDraft && (
        <div className="flex justify-between items-center gap-2">
          <span className="text-sm text-gray-600">{t('VISIT_NUMBER')}:</span>
          <span className="text-sm font-semibold text-gray-800">{data?.visitNumber ?? '-'}</span>
        </div>
      )}

      <div className="font-bold text-base mt-2">{t('CUSTOMER_INFO')}</div>

      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">
          {t((data.personType || 1) === 1 ? 'NATIONAL_CODE' : (data.personType === 2 ? 'IDENTITY_CODE' : 'PASSPORT_NUMBER'))}:
        </span>
        <div className="text-sm font-semibold text-gray-800">{data?.identityCode}</div>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">
          {t((data.personType || 1) === 1 || data.personType === 3 ? 'FULL_NAME' : 'COMPANY_NAME')}:
        </span>
        <span className="text-sm font-semibold text-gray-800">{`${data?.firstName} ${data?.lastName}`}</span>
      </div>
      <div className="flex justify-between items-center gap-2">
        <span className="text-sm text-gray-600">{t('MOBILE_PHONE_NUMBER')}:</span>
        <span className="text-sm font-semibold text-gray-800">{data?.mobilePhoneNumber}</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sm text-gray-600">{t('ADDRESS')}:</span>
        <span className="text-sm font-semibold text-gray-800 w-full">{data?.address}</span>
      </div>

      {data?.visitLocationType == 1 && (
        <div className="border border-gray-300 border-dashed h-72 rounded-lg">
          <div ref={mapRef} style={{ width: '100%', height: '250px' }} />
        </div>
      )}
    </>
  )
}

export default VisitMainData
